export const CONFIRM_PRIVACY_POLICY = (state) => {
  state.confirmPrivacyPolicy = true
}

export const SET_LOADING = (state, data) => {
  state.loading = data
}

export const SET_LANGUAGE = (state, locale) => {
  state.language = locale
}

export const SET_SERVER_VERSION = (state, serverVersion) => {
  state.serverVersion = serverVersion
}

export const updateTime = (state) => {
  state.now = new Date()
}

export const UPDATE_LAST_VERSION = (state, newVersion) => {
  state.lastVersion = newVersion
}



// WEBPACK FOOTER //
// ./src/store/mutations.js